<template>
    <div class="animated fadeIn">
        <b-card class="card-accent-info">

            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="openCleanArchitectureModal()" style="width: 200px"><span>Clean Architecture</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="goToSendPost()" style="width: 200px"><span>Send Post</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="goToRestApiClient()" style="width: 200px"><span>Rest API Client</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="openDocumentTemplatePdfModal()" style="width: 200px"><span>Gerar PDF do Modelo de Documento</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="openSignatureModal()" style="width: 200px"><span>Assinatura</span></b-button>
              </b-form-group>
            </b-col>

        </b-card>

        <b-card class="card-accent-info">
          <b-col cols="auto" class="">
            <b-form-group>
              <b-button variant="github" class="mr-1 btn-brand" @click="openOrganizationChartModal()" style="width: 200px"><span>Organograma</span></b-button>
            </b-form-group>
          </b-col>

          <b-col cols="auto" class="">
            <b-form-group>
              <b-button variant="github" class="mr-1 btn-brand" @click="openSimpleOrganizationChartModal()" style="width: 200px"><span>Organograma Simples</span></b-button>
            </b-form-group>
          </b-col>
        </b-card>

        <b-card class="card-accent-info">
          <b-col cols="auto" class="">
            <b-form-group>
              <b-button variant="github" class="mr-1 btn-brand" @click="openAgenda()" style="width: 200px"><span>Agenda</span></b-button>
            </b-form-group>
          </b-col>
        </b-card>


        <b-modal
              v-model="cleanArchitectureModal"
              id="clean-architecture-modal"
              centered
              hide-footer
              title="Clean Architecture"
              size="lg">

            <clean-architecture-component></clean-architecture-component>

         </b-modal>

         <b-modal
              v-model="documentTemplatePdfModal"
              id="document-template-pdf-modal"
              centered
              hide-footer
              title="PDF do Modelo de Documento"
              size="lg">
              <document-template-pdf-component></document-template-pdf-component>
         </b-modal>

         <b-modal
              v-model="signatureModal"
              id="signature-modal"
              centered
              hide-footer
              title="Assinatura"
              size="lg">
              <signature-component></signature-component>
         </b-modal>

         <b-modal
              v-model="organizationChartModal"
              id="organization-chart-modal"
              centered
              hide-footer
              title="Organograma"
              size="xl">

            <organization-chart-component></organization-chart-component>

         </b-modal>

         <b-modal
              v-model="simpleOrganizationChartModal"
              id="simple-organization-chart-modal"
              centered
              hide-footer
              title="Organograma"
              size="xl">

            <simple-organization-chart-component></simple-organization-chart-component>

         </b-modal>

         <b-modal
              v-model="agendaModal"
              id="agenda-modal"
              centered
              hide-footer
              title="Agendamento de Salas"
              size="xl">

            <agenda-component></agenda-component>

         </b-modal>

    </div>
</template>

<script>
import DocumentTemplatePdfComponent from './DocumentTemplatePdfComponent'
import CleanArchitectureComponent from './CleanArchitectureComponent'
import SignatureComponent from './SignatureComponent'
import OrganizationChartComponent from './OrganizationChartComponent'
import SimpleOrganizationChartComponent from './SimpleOrganizationChartComponent'
import AgendaComponent from './AgendaComponent.vue'

import Vue from 'vue'
import axios from "axios";

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */

export default {
    name: 'dev',
    components: {
        DocumentTemplatePdfComponent,
        CleanArchitectureComponent,
        SignatureComponent,
        OrganizationChartComponent,
        SimpleOrganizationChartComponent,
        AgendaComponent
    },
    data: function() {
        return {
            documentTemplatePdfModal: false,
            cleanArchitectureModal: false,
            signatureModal: false,
            organizationChartModal: false,
            simpleOrganizationChartModal: false,
            agendaModal: false
        }
    },
    methods: {
        openSignatureModal() {
          this.signatureModal = true
        },
        openDocumentTemplatePdfModal() {
            this.documentTemplatePdfModal = true
        },
        openCleanArchitectureModal() {
            this.cleanArchitectureModal = true
        },

        openOrganizationChartModal() {
            this.organizationChartModal = true
        },

        openSimpleOrganizationChartModal() {
            this.simpleOrganizationChartModal = true
        },

        goToRestApiClient() {
            this.$router.push({ path: '/development/restapiclient' })
        },

        goToSendPost() {
            this.$router.push({ path: '/development/sendpost' })
        },

        openAgenda() {
            this.agendaModal = true
        }
    }
}
</script>
  
<style>
/* IE fix */
#card-chart-01, #card-chart-02 {
    width: 100% !important;
}
</style>
  